import type {VehicleListStatusBadge} from "@/src/modules/vehicles/lib/vehicle-list-amenity-badges";
import {getVehicleStoredTrackingDisplay} from "@/src/modules/vehicles/lib/stored-tracking-label";
import type {Vehicle} from "@/src/modules/vehicles/types";

export type VehicleCheckMatchStatusRow = {
  id: "stored" | "citation";
  label: string;
  display: VehicleListStatusBadge;
};

export function getVehicleCheckCitationRiskDisplay(
  vehicle: Pick<Vehicle, "citation_assessment">,
): VehicleListStatusBadge {
  const assessment = vehicle.citation_assessment;
  if (!assessment) {
    return {label: "Unknown", variant: "secondary"};
  }

  const towStatus = assessment.tow.status;
  if (towStatus === "recommended") {
    return {label: "Tow recommended", variant: "destructive"};
  }
  if (towStatus === "at_risk" || assessment.tow.citation_types_below_threshold_at_risk.length > 0) {
    return {label: "At risk of citation", variant: "warning"};
  }

  const total = assessment.counts.total ?? 0;
  if (total > 0) {
    return {label: `${total} in period`, variant: "secondary"};
  }

  return {label: "Not at risk", variant: "secondary"};
}

export function getVehicleCheckEnforcementStatusRows(vehicle: Vehicle): VehicleCheckMatchStatusRow[] {
  const stored = getVehicleStoredTrackingDisplay(vehicle.stored_vehicles);
  const storedDisplay: VehicleListStatusBadge =
    stored.label === "None"
      ? {label: "None", variant: "secondary"}
      : {label: stored.label, variant: stored.variant};

  return [
    {
      id: "stored",
      label: "Stored",
      display: storedDisplay,
    },
    {
      id: "citation",
      label: "Citation",
      display: getVehicleCheckCitationRiskDisplay(vehicle),
    },
  ];
}

/** @deprecated Use getVehicleCheckEnforcementStatusRows + VehicleCheckAuthorizationStatus */
export function getVehicleCheckMatchStatusRows(vehicle: Vehicle): VehicleCheckMatchStatusRow[] {
  return getVehicleCheckEnforcementStatusRows(vehicle);
}
